import { Color, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { Avatar } from '../../Avatar'
import { User } from '../AccessGroup'
import { getAvatarColor } from '../utils/getAvatarColor'
import * as Styled from './styles'

interface AccessGroupPopoverProps {
  users: User[]
}

export const AccessGroupPopover = ({ users }: AccessGroupPopoverProps): ReactElement => (
  <Styled.Popover>
    {users.map((user, index) => (
      <Styled.PopoverItem key={user.id}>
        <Avatar noMargin name={user.name} backgroundColor={getAvatarColor(index)} size="m" />
        <Text as="span" variant="bodyMD" color={Color.Black}>
          {user.name}
        </Text>
      </Styled.PopoverItem>
    ))}
  </Styled.Popover>
)
